import { useTransition } from "react";
import { toast } from "sonner";

import { settleRedirect } from "@/lib/redirect-error";

export type StandardActionResult = { ok: true; id: string } | { ok: false; message: string };

// 참여 액션 공통 — 실패 문구는 액션이 준 그대로 띄우고, 성공이면 onDone(id) · 이동 신호는 삼킨다.
export const useStandardAction = () => {
  const [pending, startTransition] = useTransition();
  const run = (call: () => Promise<StandardActionResult>, onDone: (id: string) => void) =>
    startTransition(async () => {
      try {
        const result = await call();
        if (result.ok) onDone(result.id);
        else toast.error(result.message);
      } catch (caught) {
        if (settleRedirect(caught)) return;
        toast.error("저장하지 못했습니다. 잠시 후 다시 시도하세요.");
      }
    });
  return { pending, run };
};
